<span><i class="fa fa-fw" [class.fa-arrow-up]="value > 0" [class.fa-arrow-down]="value < 0"></i>{{value}}%</span>
